import { render, staticRenderFns } from "./logo-primary.vue?vue&type=template&id=af722af8&scoped=true&"
import script from "./logo-primary.vue?vue&type=script&lang=js&"
export * from "./logo-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af722af8",
  null
  
)

export default component.exports